import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const types = {
  error: {
    icon: /*#__PURE__*/_jsx("div", {
      className: "error",
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "error",
        size: 100
      })
    }),
    backgroundColor: '#FFEFEF80'
  }
};
const OverlayMessageView = props => /*#__PURE__*/_jsx("div", {
  className: "overlay d-flex justify-content-center align-items-start",
  style: {
    padding: '200px 45px 0 95px',
    zIndex: 2,
    ...props.containerStyle
  },
  children: /*#__PURE__*/_jsxs("div", {
    className: "flex-container column center w-100 p-5",
    style: {
      backgroundColor: types[props.type].backgroundColor
    },
    children: [types[props.type].icon, /*#__PURE__*/_jsx("h2", {
      className: "mt-4",
      children: props.message
    }), props.children]
  })
});
OverlayMessageView.defaultProps = {
  containerStyle: {}
};
OverlayMessageView.propTypes = {
  type: PropTypes.oneOf(['error']).isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  containerStyle: PropTypes.object
};
export default OverlayMessageView;